import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Custom Capabilities
const SmallMoleculesSynthesis = lazy(() => import('../CustomCapabilities/SmallMoleculesSynthesis'));
const LargeMoleculeSynthesis = lazy(() => import('../CustomCapabilities/LargeMoleculeSynthesis'));
const DrugAndProcessDevelopment = lazy(() => import('../CustomCapabilities/DrugAndProcessDevelopment'));
const ImpurityProfiling = lazy(() => import('../CustomCapabilities/ImpurityProfiling'));
const PolymorphismStudies = lazy(() => import('../CustomCapabilities/PolymorphismStudies'));
const DeuteratedCompounds = lazy(() => import('../CustomCapabilities/DeuteratedCompounds'));

// Analytical Capabilities
const MethodDevelopment = lazy(() => import('../AnalyticalCapabilities/MethodDevelopment'));
const MethodValidation = lazy(() => import('../AnalyticalCapabilities/MethodValidation'));
const MethodTransfer = lazy(() => import('../AnalyticalCapabilities/MethodTransfer'));
const StabilityStudies = lazy(() => import('../AnalyticalCapabilities/StabilityStudies'));
const StructureElucidation = lazy(() => import('../AnalyticalCapabilities/StructureElucidation'));

// Regulatory Services
// const RegulatoryConsulting = lazy(() => import('../RegulatoryServices/RegulatoryConsulting'));
// const DossierPreparation = lazy(() => import('../RegulatoryServices/DossierPreparation'));
// const DMFAndANDASubmissions = lazy(() => import('../RegulatoryServices/DMFAndANDASubmissions'));

// Analytical Testing
// const WetLabAnalysis = lazy(() => import('../AnalyticalTesting/WetLabAnalysis'));
// const InstrumentationAnalysis = lazy(() => import('../AnalyticalTesting/InstrumentationAnalysis'));
// const SpecializedTesting = lazy(() => import('../AnalyticalTesting/SpecializedTesting'));

// Trainings and Audits
// const Audits = lazy(() => import('../TrainingsAndAudits/Audits'));
// const GMPGLPTrainings = lazy(() => import('../TrainingsAndAudits/GMPorGLPTrainings'));

// Other
// const BasicResearch = lazy(() => import('../Other/BasicResearch'));
// const FTEBasedProjects = lazy(() => import('../Other/FTEBasedProjects'));

function ServiceRoutes() {
  return (
    <Suspense fallback={<div>⏳Loading...</div>}>
      <Routes>
        {/* Custom Capabilities */}
        <Route path="/services/small-molecules" element={<SmallMoleculesSynthesis />} />
        <Route path="/services/large-molecules" element={<LargeMoleculeSynthesis />} />
        <Route path="/services/drug-process-development" element={<DrugAndProcessDevelopment />} />
        <Route path="/services/impurity-profiling" element={<ImpurityProfiling />} />
        <Route path="/services/polymorphism-studies" element={<PolymorphismStudies />} />
        <Route path="/services/deuterated-compounds" element={<DeuteratedCompounds />} />

        {/* Analytical Capabilities */}
        <Route path="/services/method-development" element={<MethodDevelopment />} />
        <Route path="/services/method-validation" element={<MethodValidation />} />
        <Route path="/services/method-transfer" element={<MethodTransfer />} />
        <Route path="/services/stability-studies" element={<StabilityStudies />} />
        <Route path="/services/structure-elucidation" element={<StructureElucidation />} />

        {/* Regulatory Services */}
        {/* <Route path="/services/regulatory-consulting" element={<RegulatoryConsulting />} />
        <Route path="/services/dossier-preparation" element={<DossierPreparation />} />
        <Route path="/services/dmf-anda-submissions" element={<DMFAndANDASubmissions />} /> */}

        {/* Analytical Testing */}
        {/* <Route path="/services/wet-lab-analysis" element={<WetLabAnalysis />} />
        <Route path="/services/instrumentation-analysis" element={<InstrumentationAnalysis />} />
        <Route path="/services/specialized-testing" element={<SpecializedTesting />} /> */}

        {/* Trainings and Audits */}
        {/* <Route path="/services/audits" element={<Audits />} />
        <Route path="/services/gmp-glp-trainings" element={<GMPGLPTrainings />} /> */}

        {/* Other */}
        {/* <Route path="/services/basic-research" element={<BasicResearch />} />
        <Route path="/services/fte-projects" element={<FTEBasedProjects />} /> */}
      </Routes>
    </Suspense>
  );
}

export default ServiceRoutes;
